import {useEffect, useState} from "react";
import {Link, useParams} from "react-router-dom";
import {getDraws} from "../services/api";

export function ListDraws() {
    const { decisionId } = useParams()
    const [draws, setDraws] = useState([])
    useEffect(() => {
        getDraws(decisionId)
            .then(apiDraws => {
                setDraws(apiDraws)
            })
            .catch(ex => {
                console.log("Error getting draws");
            })
    }, [])
    
    return (
        <>
            {draws && 
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Date</th>
                            <th>Chosen</th>
                            <th>Result</th>
                            <th>Odds</th>
                        </tr>
                    </thead>
                    <tbody>
                    {draws.map(d => {
                        return <tr key={d.drawId}>
                            <td><Link to={`/draws/${d.drawId}/edit`}>{d.name}</Link></td>
                            <td>{new Date(d.date).toLocaleDateString()}</td>
                            <td>{d.chosenFlag ? "Yes" : "No"}</td>
                            <td>{d.result}</td>
                            <td>{d.odds}</td>
                        </tr>
                        })}
                    </tbody>

                </table>
            }
            <div className="mt-3">
                <Link to={`/decisions/${decisionId}/edit`} className="btn btn-primary">Edit</Link>
            </div>
        </>
    )
}